// Paleta TicketFacil (roxo/violeta)
const palette = {
  light: {
    primary: {
      main: "#6D28D9",
      dark: "#5B21B6",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#8B5CF6",
      dark: "#7C3AED",
    },
    success: { main: "#2E7D32" },
    error: { main: "#D32F2F" },
    text: { secondary: "rgba(30, 27, 46, 0.62)" },
    background: {
      default: "#F6F5FA",
      paper: "#FCFBFF",
      chat: "#F5F3FF",
    },
    action: { selected: "rgba(109, 40, 217, 0.10)" },
    cards: { background: "#FFF" },
    appBar: { background: "#5B21B6" },
    scrollbar: { thumb: "rgba(91, 33, 182, .18)" },
    userMessage: { main: "#EDE9FE" },
    contactMessage: { main: "#FFFFFF" },
    timestamp: { background: "#EDE9FE" },
    queue: { fallback: "#7C7C7C" },
  },
  dark: {
    primary: {
      main: "#A78BFA",
      dark: "#8B5CF6",
      contrastText: "#1E1B2E",
    },
    secondary: {
      main: "#C4B5FD",
      dark: "#A78BFA",
    },
    success: { main: "#66BB6A" },
    error: { main: "#F44336" },
    background: {
      default: "#1E1B2E",
      paper: "#181626",
      chat: "#13111F",
    },
    action: { selected: "#2D2845" },
    cards: { background: "#262238" },
    appBar: { background: "#2E1065" },
    scrollbar: { thumb: "hsla(258, 90%, 80%, .16)" },
    userMessage: { main: "#4C1D95" },
    contactMessage: { main: "#262238" },
    timestamp: { background: "#2D2845" },
    queue: { fallback: "#7C7C7C" },
  },
};

export default palette;
